module.exports = __webpack_public_path__ + "static/media/scholar.cc7392a2.png";